import { render, staticRenderFns } from "./MenuKPIs.vue?vue&type=template&id=d230df00&scoped=true&"
import script from "./MenuKPIs.vue?vue&type=script&lang=js&"
export * from "./MenuKPIs.vue?vue&type=script&lang=js&"
import style0 from "./MenuKPIs.vue?vue&type=style&index=0&id=d230df00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d230df00",
  null
  
)

export default component.exports